import ComponentManager from "../../componentFramework";
import EventListenerManager from "../EventListenerManager";

/**
 */
@ComponentManager.register()
export default class ExternalLinkField {
	public static componentStyleClass = "externalLinkField";

	protected readonly eventListenerManager = new EventListenerManager();

	constructor(private readonly rootElement: HTMLElement) {
		const previewButton = rootElement.querySelector<HTMLElement>(".externalLinkField__preview");
		if (previewButton !== null) {
			this.eventListenerManager.manage(previewButton).addEventListener("click", this.onPreviewClick);
		}
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		this.eventListenerManager.removeListeners();
	}

	private onPreviewClick = (ev: MouseEvent) => {
		const url = this.getUrl();

		if (url !== null && url.length > 0) {
			const width = Math.min(950, window.screen.availWidth - 10);
			const height = Math.min(500, window.screen.availHeight - 10);
			const left = Math.max(0, (window.screen.availWidth - width) / 2);
			const top = Math.max(0, (window.screen.availHeight - height) / 2);
			window.open(
				url,
				"externalLinkFieldPreview",
				`toolbar=0,scrollbars=1,location=0,statusbar=0,menubar=0,resizable=0,width=${width},height=${height},left=${left},top=${top}`
			);
		}

		ev.preventDefault();
		return false;
	}

	private getUrl(): string | null {
		const input = this.rootElement.querySelector<HTMLInputElement>(".externalLinkField__input");
		return input === null || input.value.length === 0 ? null : input.value;
	}
}

